<nc-confirmation-dialog titleLabel="{{ title }}">
	{{ message | translate }}
</nc-confirmation-dialog>
